import * as React from "react";

type Props = {
  className?: string;
  style?: React.CSSProperties;
};

export const UpDown = (props: Props) => (
  <svg
    {...props}
    version="1.1"
    id="Capa_1"
    x="0px"
    y="0px"
    viewBox="0 0 401.998 401.998"
    xmlSpace="preserve"
  >
    <g>
      <g>
        <path
          d="M73.092,164.452h255.813c4.949,0,9.233-1.807,12.848-5.424c3.613-3.616,5.427-7.898,5.427-12.847
          c0-4.949-1.813-9.229-5.427-12.85L213.846,5.424C210.232,1.812,205.951,0,200.999,0s-9.233,1.812-12.85,5.424L60.242,133.331
          c-3.617,3.617-5.424,7.901-5.424,12.85c0,4.948,1.807,9.231,5.424,12.847C63.863,162.645,68.144,164.452,73.092,164.452z"
        />
        <path
          d="M328.905,237.549H73.092c-4.952,0-9.233,1.808-12.85,5.421c-3.617,3.617-5.424,7.898-5.424,12.847
          c0,4.949,1.807,9.233,5.424,12.848L188.149,396.57c3.621,3.617,7.902,5.428,12.85,5.428s9.233-1.811,12.847-5.428l127.907-127.906
          c3.613-3.614,5.427-7.898,5.427-12.848c0-4.948-1.813-9.229-5.427-12.847C338.139,239.353,333.854,237.549,328.905,237.549z"
        />
      </g>
    </g>
  </svg>
);

export const Up = (props: Props) => (
  <svg id="Capa_1" viewBox="0 0 292.362 292.362" {...props}>
    <path d="M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424 C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428 s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z" />
  </svg>
);

export const Down = (props: Props) => (
  <Up style={{ transform: "rotate(180deg)" }} {...props} />
);
